{
  "de": {
    "labels": {
      "true": "Ja",
      "false": "Nein",
      "null": "-",
      "and": "und",
      "hide": "Verbergen",
      "show": "Anzeigen",
      "only": "Nur",
      "description": "Beschreibung",
      "unavailable": "nicht verfügbar",
      "selected": "Ausgewählt",
      "actions": "Aktionen",
      "enabled": "Aktiviert",
      "disabled": "Deaktiviert",
      "collapse": "Einklappen",
      "price": "Preis",
      "expand": "Ausklappen",
      "distance": "Entfernung",
      "anonymous": "Anonym",
      "toggleNavigation": "Navigation umschalten",
      "enableYoutube": "Klicken Sie, um Youtube-Einbettungen zu aktivieren, oder rechtsklicken Sie, um die Video-URL zu kopieren",
      "openInNewWindow": "Im Vollbild öffnen",
      "or": "oder",
      "deselect": "Klicken zum Abwählen",
      "networkStatusOffline": "Netzwerkstatus: Offline - Dienst nicht verfügbar",
      "groups": "Gruppen",
      "features": {
        "stateOn": "Aktiviert",
        "stateOff": "Deaktiviert",
        "stateConditional": "Bedingt",
        "selfService": "Self-Service",
        "selfServiceEnabled": "Benutzer können diese Funktion umschalten",
        "selfServiceDisabled": "Benutzer können diese Funktion nicht umschalten",
        "actors": "Akteure",
        "groups": "Gruppen",
        "noGroups": "Keine Gruppen für diese Funktion aktiviert.",
        "noActors": "Keine einzelnen Akteure für diese Funktion aktiviert.",
        "user": "Benutzer",
        "fleet": "Flotte",
        "actorType": "Akteurtyp",
        "percentageOfActors": "der Akteure",
        "percentageOfTime": "der Zeit",
        "currentState": "Aktueller Status",
        "toggle": "Umschalten",
        "settingsIntro": "Aktivieren oder deaktivieren Sie experimentelle Funktionen für Ihr Konto. Diese Funktionen können unvollständig sein oder sich ohne Vorankündigung ändern.",
        "noFeaturesAvailable": "Derzeit sind keine Self-Service-Funktionen verfügbar.",
        "descriptions": {
          "tools_travel_times": "Geschätzte Reisezeiten zwischen Standorten anzeigen.",
          "tools_cargo_grids": "Interaktiven Frachtraster-Viewer für Schiffe anzeigen.",
          "fleet_starmap": "Star Citizen Sternenkarte auf Flottenmitgliederseiten anzeigen."
        }
      },
      "oauthApplication": {
        "name": "Anwendungsname",
        "clientId": "Client-ID",
        "clientSecret": "Client-Secret",
        "redirectUri": "Weiterleitungs-URI",
        "redirectUriHint": "Verwenden Sie eine URI pro Zeile.",
        "confidential": "Vertraulich",
        "scopes": "Berechtigungen",
        "scopesHint": "Wenn keine Berechtigungen ausgewählt sind, werden die Standardberechtigungen verwendet: %{scopes}"
      },
      "rsiRequestLogs": {
        "resolved": "Gelöst",
        "unresolved": "Ungelöst"
      },
      "imports": {
        "type": "Typ",
        "status": "Status",
        "version": "Version",
        "startedAt": "Gestartet",
        "finishedAt": "Beendet",
        "failedAt": "Fehlgeschlagen am",
        "info": "Info",
        "input": "Eingabe",
        "output": "Ausgabe",
        "importData": "Importdaten",
        "file": "Importierte Datei",
        "requestedBy": "Angefordert von",
        "adminUser": "Admin Benutzer",
        "user": "Benutzer",
        "includeSystem": "System einschließen",
        "systemRequester": "System",
        "statuses": {
          "created": "Wartend",
          "started": "Läuft",
          "finished": "Abgeschlossen",
          "failed": "Fehlgeschlagen"
        }
      },
      "oauthApplications": {
        "settingsIntro": "Verwalten Sie Ihre OAuth-Anwendungen. Diese Anwendungen können im Namen von Benutzern auf die FleetYards-API zugreifen.",
        "name": "Anwendungsname",
        "redirectUri": "Weiterleitungs-URI",
        "confidential": "Vertraulich",
        "clientId": "Client-ID",
        "clientSecret": "Client-Secret",
        "scopes": "Berechtigungen",
        "defaultScopes": "Standard-Berechtigungen",
        "confidentialShort": "Vertraulich",
        "publicShort": "Öffentlich"
      },
      "fleetInviteToken": "Flotteneinladung",
      "scDataVersion": "Patch-Version",
      "lastReload": "Letzte Aktualisierung",
      "createdAt": "Erstellt am",
      "updatedAt": "Aktualisiert am",
      "addToHangar": "Zum Hangar hinzufügen",
      "home": {
        "search": "Schiffe suchen..."
      },
      "shop": {
        "rentalPrice": "Miete",
        "sellPrice": "verkauft für",
        "buyPrice": "kauft für"
      },
      "shopCommodity": {
        "item": "Gegenstand",
        "shop": "Geschäft",
        "sellPrices": "Verkaufspreise",
        "buyPrices": "Kaufpreise",
        "rentalPrices": "Mietpreise",
        "confirmed": "Bestätigt?",
        "submittedBy": "Eingereicht von",
        "prices": {
          "label": "Preise",
          "rentalPrice": "Miete",
          "averageRentalPrice": "rental (Ø)",
          "sellPrice": "verkauft für",
          "averageSellPrice": "sells for (Ø)",
          "buyPrice": "kauft für",
          "averageBuyPrice": "buys for (Ø)",
          "rentalPrice1Day": "1 Day for",
          "averageRentalPrice1Day": "1 Day for (Ø)",
          "rentalPrice3Days": "3 Days for",
          "averageRentalPrice3Days": "3 Days for (Ø)",
          "rentalPrice7Days": "7 Days for",
          "averageRentalPrice7Days": "7 Days for (Ø)",
          "rentalPrice30Days": "30 Days for",
          "averageRentalPrice30Days": "30 Days for (Ø)"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "Neue Schiffe in %{year}",
          "totalShips": "Schiffe gesamt",
          "totalMembers": "Mitglieder gesamt",
          "vehicles": "Hangar Schiffe",
          "wishlists": "Wunschliste Schiffe",
          "shipOfTheMonth": "Schiff des Monats"
        },
        "modelsByClassification": "Ships by Classification",
        "modelsBySize": "Ships by Size",
        "vehiclesByModel": "Ships by Model (Top %{limit})",
        "modelsPerMonth": "Ships per Month",
        "modelsByManufacturer": "Ships by Manufacturer",
        "modelsByProductionStatus": "Ships by Production Status",
        "vehiclesPerMonth": "Hangar Schiffe pro Monat",
        "topVehiclesByModel": "Top 10 Hangar Schiffe",
        "shipsOfTheMonth": "Schiff des Monats",
        "crewDeficit": "Crew Defizit",
        "crewSurplus": "Crew Überschuss",
        "membersByRole": "Mitglieder nach Rolle"
      },
      "roadmap": {
        "selectWeek": "Woche auswählen",
        "shipRoadmap": "Schiff-Roadmap",
        "releases": "Veröffentlichungen",
        "unscheduled": "Ungeplant",
        "lastUpdate": "Letzte Aktualisierung",
        "released": "Veröffentlicht",
        "recentlyUpdated": "Kürzlich aktualisiert",
        "committed": "Festgelegt",
        "lastVersion": {
          "active": {
            "false": "Element wurde von der Roadmap entfernt",
            "true": "Element wurde wieder zur Roadmap hinzugefügt",
            "decreased": "Item was removed from the Roadmap",
            "increased": "Item was readded to the Roadmap"
          },
          "committed": "Item was marked as committed",
          "released": "Item was released to PU",
          "release": "Item moved from release %{old} to %{new}",
          "addedToRelease": "Item new in release %{release}"
        },
        "stories": {
          "one": "%{count} Story",
          "other": "%{count} Stories"
        },
        "tasks": {
          "one": "of %{count} Task",
          "other": "of %{count} Tasks"
        },
        "ships": {
          "one": "%{count} Ship",
          "other": "%{count} Ships"
        }
      },
      "rsiRoadmap": "RSI Roadmap",
      "unknown": "Unbekannt",
      "none": "-",
      "notAvailable": "N/A",
      "unknownModel": "%{slug} Unknown",
      "not-available": "N/A",
      "receiveSaleNotifications": "",
      "publicUrl": "Öffentliche URL",
      "name": "Name",
      "homepage": "Homepage",
      "discord": "Discord-Server",
      "youtube": "Youtube-Kanal",
      "twitch": "Twitch-Kanal",
      "guilded": "Guilded-Server",
      "3dView": "3D",
      "3dMap": "Map",
      "filter": "Filter",
      "taxExcluded": "zzgl. MwSt.",
      "hangar": "Hangar",
      "public": "Öffentlich",
      "hangarStats": "Statistiken",
      "wishlist": "Wunschliste",
      "fleetchart": "Flottenübersicht",
      "fleetchartApp": {
        "screenHeight": "Bildschirmhöhe",
        "viewpoint": "Blickpunkt",
        "screenHeightOptions": {
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "side": "Seite",
          "top": "Oben",
          "angled": "Schräg",
          "front": "Front"
        },
        "gridSize": "%{size} Meter pro Rasterfeld",
        "mode": "Modus",
        "modeOptions": {
          "classic": "Klassisch",
          "panzoom": "v2"
        }
      },
      "fleetStats": "Statistiken",
      "hangarMetrics": {
        "total": "Gesamt",
        "totalMoney": "Pledge-Wert",
        "totalCredits": "In-Game gekauft Wert",
        "totalIngameValue": "Hangar aUEC-Wert",
        "totalMinCrew": "Min. Besatzung",
        "totalMaxCrew": "Max. Besatzung",
        "totalCargo": "Gesamtfracht",
        "largestShip": "Größtes Schiff",
        "smallestShip": "Kleinstes Schiff",
        "averagePledgePrice": "Ø Pledge-Preis",
        "flightReady": "Flugbereit",
        "uniqueModels": "Einzigartige Modelle",
        "manufacturerCount": "Hersteller",
        "missingClassifications": "Fehlende Rollen",
        "wishlistTotalMoney": "Wunschliste Pledge-Wert",
        "wishlistTotalCredits": "Wunschliste In-Game-Wert"
      },
      "selectModel": "Schiff auswählen",
      "findModel": "Tippen, um ein Schiff zu suchen",
      "find": "Suchbegriff eintippen",
      "selectUser": "Benutzer auswählen",
      "findUser": "Tippen, um einen Benutzer zu suchen",
      "selectAdminUser": "Admin Benutzer auswählen",
      "selectFleet": "Flotte auswählen",
      "findFleet": "Tippen, um eine Flotte zu suchen",
      "compare": {
        "removeModel": "Schiff entfernen",
        "addModel": {
          "nullablePrompt": "Schiff hinzufügen"
        },
        "enough": "Don't you think 8 Ships are enough? ;)"
      },
      "cargoRoutes": "Frachtrouten",
      "uecPerUnit": "aUEC / Unit",
      "au": "AU",
      "uec": "aUEC",
      "sell": "Verkaufen",
      "buy": "Kaufen",
      "yourFlagship": "Ihr Flaggschiff",
      "flagship": "Flaggschiff",
      "fleet": {
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "Flotte",
        "fid": "Flotten-ID",
        "name": "Name",
        "logo": "Logo",
        "rsiSid": "SID",
        "description": "Beschreibung",
        "public": "Öffentliche Flottenansicht",
        "publicFleet": "Öffentliche Flotte",
        "publicStats": "Öffentliche Statistiken",
        "publicFleetStats": "Öffentliche Flottenstatistiken",
        "discord": "Discord-Server",
        "guilded": "Guilded-Server",
        "homepage": "Homepage",
        "twitch": "Twitch-Kanal",
        "youtube": "Youtube-Kanal",
        "backgroundImage": "Hintergrundbild",
        "ts": "Teamspeak-Server",
        "awaitingConfirmation": "Wartet auf Bestätigung durch die Flotte",
        "members": {
          "primary": "Primäre Flotte?",
          "hideShips": "Ihre Schiffe für diese Flotte verbergen?",
          "shipsFilter": {
            "label": "Welche Schiffe sollen zur Flotte hinzugefügt werden?",
            "nullablePrompt": "Keine Option ausgewählt",
            "field": "Schiffsauswahl",
            "values": {
              "all": "Alle Schiffe",
              "hangar_group": "Alle Schiffe in einer bestimmten Hangar-Gruppe",
              "hide": "Keine Schiffe"
            }
          },
          "hangarGroupId": {
            "field": "Hangar-Gruppe",
            "label": "Hangar-Gruppe angeben",
            "nullablePrompt": "Keine Gruppe ausgewählt"
          },
          "total": "Gesamt: %{count}",
          "joined": "Beigetreten am",
          "invited": "Eingeladen",
          "invitedAt": "Eingeladen / Angefragt am",
          "requested": "Mitgliedschaft angefragt",
          "declined": "Abgelehnt",
          "pending": "Ausstehende Einladungen & Anfragen",
          "accepted": "Mitglieder",
          "declinedMembers": "Abgelehnt",
          "role": "Rolle",
          "roles": {
            "admin": "Admin",
            "officer": "Offizier",
            "member": "Mitglied"
          },
          "contact": "Kontakt",
          "spectrumDm": "Nachricht auf Spectrum",
          "discordContact": "Discord"
        },
        "roles": {
          "permanent": "Permanent",
          "privilegeGroups": {
            "fleet": "Flotte",
            "memberships": "Mitglieder",
            "invites": "Einladungen",
            "vehicles": "Fahrzeuge",
            "roles": "Rollen"
          },
          "privileges": {
            "fleet:update": "Flotte bearbeiten",
            "fleet:update:images": "Bilder bearbeiten",
            "fleet:update:description": "Beschreibung bearbeiten",
            "fleet:delete": "Flotte löschen",
            "fleet:manage": "Flotte verwalten",
            "fleet:memberships:read": "Mitglieder ansehen",
            "fleet:memberships:create": "Mitglieder einladen",
            "fleet:memberships:update": "Mitglieder bearbeiten",
            "fleet:memberships:delete": "Mitglieder entfernen",
            "fleet:memberships:manage": "Mitglieder verwalten",
            "fleet:invites:read": "Einladungen ansehen",
            "fleet:invites:create": "Einladungen erstellen",
            "fleet:invites:delete": "Einladungen löschen",
            "fleet:invites:manage": "Einladungen verwalten",
            "fleet:vehicles:read": "Fahrzeuge ansehen",
            "fleet:vehicles:create": "Fahrzeuge hinzufügen",
            "fleet:vehicles:update": "Fahrzeuge bearbeiten",
            "fleet:vehicles:delete": "Fahrzeuge entfernen",
            "fleet:vehicles:manage": "Fahrzeuge verwalten",
            "fleet:roles:read": "Rollen ansehen",
            "fleet:roles:create": "Rollen erstellen",
            "fleet:roles:update": "Rollen bearbeiten",
            "fleet:roles:delete": "Rollen löschen",
            "fleet:roles:manage": "Rollen verwalten"
          }
        },
        "inviteUrls": {
          "noLimit": "Kein Limit",
          "noExpiration": "Läuft nie ab",
          "usesLeft": "%{count} Nutzungen übrig",
          "used": "%{count} mal verwendet",
          "usedOfLimit": "%{count} von %{limit} verwendet",
          "expiresIn": "Läuft ab in %{time}",
          "expired": "Abgelaufen",
          "expiresAfterOptions": {
            "infinite": "Never",
            "30_minutes": "30 minutes",
            "1_hour": "1 hour",
            "6_hours": "6 hours",
            "12_hours": "12 hours",
            "1_day": "1 Tag",
            "7_days": "7 days"
          },
          "limitOptions": {
            "infinite": "No limit",
            "1": "1 use",
            "5": "5 uses",
            "10": "10 uses",
            "25": "25 uses",
            "50": "50 uses",
            "100": "100 uses"
          }
        }
      },
      "hangarGroup": {
        "name": "Name",
        "color": "Farbe",
        "sort": "Sortierreihenfolge",
        "public": "Im öffentlichen Hangar anzeigen?"
      },
      "source": "Quelle",
      "model": {
        "hidden": "Versteckt?",
        "active": "Aktiv?",
        "inGame": "Im Spiel?",
        "adiMap": "ADI Map?",
        "ground": "Bodenfahrzeug?",
        "productionNote": "Produktionshinweis",
        "rsiId": "RSI ID",
        "length": "Länge",
        "beam": "Breite",
        "height": "Höhe",
        "scIdentifier": "SC Identifier",
        "price": "Preis",
        "pledgePrice": "Pledge-Preis",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "Masse",
        "minCrew": "Min. Besatzung",
        "maxCrew": "Max. Besatzung",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "Max. Geschwindigkeit",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "Fracht",
        "cargoHolds": "Frachträume",
        "hydrogenFuelTankSize": "Hydrogen-Tankgröße",
        "hydrogenFuelTanks": "Hydrogen-Treibstofftanks",
        "quantumFuelTankSize": "Quantum-Tankgröße",
        "quantumFuelTanks": "Quantum-Treibstofftanks",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "Gieren verstärkt",
        "pitchBoosted": "Neigung verstärkt",
        "rollBoosted": "Rollen verstärkt",
        "variants": "Varianten",
        "manufacturer": "Hersteller",
        "loaners": "Leihschiffe",
        "paints": "Lackierungen",
        "modules": "Module",
        "modulePackages": "Modulpakete",
        "upgrades": "Upgrade-Kits",
        "brochure": "Broschüre",
        "holo": "Holo",
        "angledView": "Schrägansicht",
        "angledViewColored": "Schrägansicht Farbig",
        "sideView": "Seitenansicht",
        "sideViewColored": "Seitenansicht Farbig",
        "frontView": "Frontansicht",
        "frontViewColored": "Frontansicht Farbig",
        "topView": "Draufsicht",
        "topViewColored": "Draufsicht Farbig",
        "onSale": "Im Angebot",
        "salesPage": "Verkaufsseite",
        "addons": "Module & Upgrade-Kits",
        "storeImage": "Shop-Bild",
        "wiki": "Star Citizen Wiki",
        "baseModel": "Basismodell",
        "fleetchartOffsetLength": "Flottenübersicht Versatz Länge",
        "fleetchartOffsetBeam": "Flottenübersicht Versatz Breite",
        "state": {
          "retracted": "Eingefahren",
          "extended": "Ausgefahren"
        },
        "productionStatus": {
          "in-production": "In Produktion",
          "in-concept": "Im Konzept",
          "ready": "Hangar-bereit",
          "flight-ready": "Flugbereit",
          "announced": "Angekündigt"
        }
      },
      "models": {
        "extraColumns": "Spalten",
        "table": {
          "columns": {
            "storeImage": "Bild",
            "storeImageWide": "Breites Bild",
            "rsiStoreImage": "RSI-Bild",
            "rsiStoreImageWide": "Breites RSI-Bild",
            "angledView": "3D-Bild",
            "angledViewWide": "Breites 3D-Bild",
            "rsiId": "RSI ID",
            "hidden": "Versteckt",
            "active": "Aktiv",
            "createdAt": "Erstellt am",
            "updatedAt": "Aktualisiert am",
            "manufacturerName": "Hersteller",
            "length": "Länge",
            "beam": "Breite",
            "height": "Höhe",
            "mass": "Masse",
            "cargo": "Fracht",
            "quantumFuelTankSize": "Quantum-Treibstoff",
            "hydrogenFuelTankSize": "Hydrogen-Treibstoff",
            "minCrew": "Besatzung",
            "maxCrew": "Max. Besatzung",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "Max. Geschwindigkeit",
            "groundMaxSpeed": "Bodengeschwindigkeit",
            "focus": "Fokus",
            "productionStatus": "Produktionsstatus",
            "price": "Preis",
            "pledgePrice": "Pledge-Preis"
          }
        }
      },
      "metrics": {
        "info": "Info",
        "levels": "Ebenen",
        "views": "Ansichten",
        "base": "Basis",
        "crew": "Besatzung",
        "speed": "Geschwindigkeit",
        "cargo": "Fracht",
        "hardpoints": "Aufhängungspunkte",
        "missileOptions": "Raketenoptionen (falls verfügbar)",
        "topView": "Top View"
      },
      "manufacturer": {
        "longName": "Vollständiger Name",
        "code": "Code",
        "logo": "Logo",
        "scRef": "SC Ref"
      },
      "fundingGoal": {
        "title": "Titel",
        "description": "Beschreibung",
        "amount": "Betrag",
        "currency": "Währung",
        "effectiveFrom": "Gültig ab",
        "endedAt": "Beendet am"
      },
      "supporterContribution": {
        "name": "Unterstützer-Name",
        "amount": "Betrag",
        "currency": "Währung",
        "anonymous": "Anonym",
        "recurring": "Wiederkehrend",
        "startedAt": "Beginnt am",
        "endedAt": "Endet am",
        "note": "Interne Notiz",
        "stats": {
          "total": "Gesamt",
          "count": "Beiträge",
          "recurringCount": "Wiederkehrend",
          "anonymousCount": "Anonym"
        }
      },
      "itemPrice": {
        "price": "Preis",
        "location": "Standort",
        "locationUrl": "Standort-URL"
      },
      "video": {
        "url": "URL",
        "videoType": "Typ"
      },
      "modelModule": {
        "name": "Name",
        "description": "Beschreibung",
        "price": "Preis",
        "pledgePrice": "Pledge-Preis",
        "productionStatus": "Produktionsstatus",
        "scKey": "SC Key",
        "storeImage": "Shop-Bild",
        "active": "Aktiv?",
        "hidden": "Versteckt?"
      },
      "dock": {
        "name": "Name",
        "dockType": "Dock-Typ",
        "shipSize": "Schiffsgröße"
      },
      "modelHardpoint": {
        "name": "Name",
        "key": "Schlüssel",
        "source": "Quelle",
        "group": "Gruppe",
        "hardpointType": "Typ",
        "size": "Größe",
        "category": "Kategorie",
        "subCategory": "Unterkategorie",
        "details": "Details",
        "mount": "Halterung",
        "itemSlots": "Gegenstandsplätze",
        "loadoutIdentifier": "Loadout-Kennung"
      },
      "modelHardpointLoadout": {
        "name": "Name"
      },
      "modelUpgrade": {
        "name": "Name",
        "description": "Beschreibung",
        "pledgePrice": "Pledge-Preis",
        "active": "Aktiv?",
        "hidden": "Versteckt?"
      },
      "modelModulePackage": {
        "name": "Name",
        "description": "Beschreibung",
        "pledgePrice": "Pledge-Preis",
        "modules": "Module",
        "active": "Aktiv?",
        "hidden": "Versteckt?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "Rotation (°)"
      },
      "modelLoaner": {
        "hidden": "Versteckt?",
        "loanerModel": "Leihmodell"
      },
      "modelPaint": {
        "hidden": "Versteckt?",
        "active": "Aktiv?",
        "onSale": "Im Angebot",
        "pledgePrice": "Pledge-Preis",
        "productionStatus": "Produktionsstatus",
        "productionNote": "Produktionshinweis"
      },
      "component": {
        "size": "Size: %{size}",
        "grade": "Qualität",
        "hidden": "Versteckt?",
        "componentClass": "Komponentenklasse",
        "componentType": "Komponententyp",
        "componentSubType": "Komponenten-Untertyp",
        "itemType": "Gegenstandstyp",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "hardpoint": {
        "legend": {
          "headline": "Legende",
          "slotTaken": "Slot belegt",
          "slotAvailable": "Slot frei"
        },
        "size": "Größe",
        "rackSize": "Rack-Größe",
        "details": "Details",
        "group": "Gruppe",
        "thrusters": {
          "thrust": "Schub",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix"
          }
        },
        "sources": {
          "game_files": "Spieldateien",
          "ship_matrix": "Ship Matrix"
        },
        "fuelTanks": {
          "hydrogen": "Hydrogen-Treibstofftank",
          "quantum": "Quantum-Treibstofftank"
        },
        "jumpDrive": "Sprungantrieb",
        "maxContainerSize": "Max. Containergröße",
        "groups": {
          "avionic": "Avionik",
          "system": "Systeme",
          "propulsion": "Antrieb",
          "thruster": "Triebwerk",
          "weapon": "Waffen",
          "other": "Sonstige",
          "auxiliary": "Hilfssysteme",
          "seat": "Sitze"
        },
        "types": {
          "radar": "Radar",
          "computers": "Computer",
          "power_plants": "Kraftwerke",
          "coolers": "Kühler",
          "shield_generators": "Schildgeneratoren",
          "fuel_intakes": "Treibstoffeinlässe",
          "fuel_tanks": "Treibstofftanks",
          "quantum_drives": "Quantum-Antriebe",
          "jump_modules": "Sprungmodule",
          "jumpdrive": "Sprungmodule",
          "quantum_fuel_tanks": "Quantum-Treibstofftanks",
          "main_thrusters": "Haupttriebwerke",
          "maneuvering_thrusters": "Manövriertriebwerke",
          "weapons": "Waffen",
          "turrets": "Geschütztürme",
          "missiles": "Raketen",
          "utility_items": "Hilfsgeräte",
          "utility": "Hilfsgeräte",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— Modul auswählen —",
        "selectModule": "Modul auswählen",
        "clearModule": "Auswahl löschen",
        "categories": {
          "radar": "Radar",
          "armor": "Panzerung",
          "relay": "Relais",
          "countermeasures": "Gegenmaßnahmen",
          "lifesupport": "Lebenserhaltung",
          "selfdestruct": "Selbstzerstörung",
          "batteries": "Batterien",
          "computers": "Computer",
          "powerplant": "Kraftwerke",
          "cooler": "Kühler",
          "module": "Module",
          "shieldgenerator": "Schildgeneratoren",
          "fuel_intakes": "Treibstoffeinlässe",
          "fueltanks": "Treibstofftanks",
          "quantumdrive": "Quantum-Antriebe & Sprungmodule",
          "jump_modules": "Sprungmodule",
          "jumpdrive": "Sprungmodule",
          "quantum_fuel_tanks": "Quantum-Treibstofftanks",
          "main_thrusters": "Haupttriebwerke",
          "maneuvering_thrusters": "Manövriertriebwerke",
          "retro_thrusters": "Retro-Triebwerke",
          "vtol_thrusters": "VTOL-Triebwerke",
          "weapons": "Waffen",
          "weapon_mounts": "Waffenhalterungen",
          "turret": "Geschütztürme",
          "missiles": "Raketen",
          "missile_racks": "Raketenträger",
          "utility_items": "Hilfsgeräte",
          "utility": "Hilfsgeräte",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "Bergungsfüllstation",
          "cargogrid": "Frachtraster",
          "seat": "Sitze"
        }
      },
      "blank": {
        "propulsion": "Kein Antrieb vorhanden",
        "ordnance": "Keine Bewaffnung vorhanden",
        "modular": "Kein Modular vorhanden",
        "avionics": "Keine Avionik vorhanden",
        "fleetInvites": "Keine Einladungen vorhanden",
        "shopCommodities": "Keine Waren verfügbar",
        "userShips": "Your Hangar is currently Empty. To Add Ships / Vehicles to Your Hangar click the following Icon on Any Ship in the Database:"
      },
      "user": {
        "rsiHandle": "Handle",
        "location": "Standort",
        "currentSystem": "Aktuelles Sternensystem",
        "tester": "Tester?",
        "avatar": "Avatar",
        "unconfirmedEmail": "Unbestätigte E-Mail",
        "saleNotify": "Ich möchte Angebotsbenachrichtigungen erhalten",
        "publicHangar": "Öffentlicher Hangar aktiviert",
        "publicHangarLoaners": "Leihschiff-Hinweis im öffentlichen Hangar anzeigen",
        "publicHangarStats": "Öffentliche Hangar-Statistiken aktiviert",
        "publicWishlist": "Öffentliche Wunschliste aktiviert",
        "hideOwner": "Besitz für Flotten verbergen",
        "lastActiveAt": "Zuletzt aktiv",
        "confirmedAt": "Bestätigt am"
      },
      "adminUser": {
        "superAdmin": "Super-Admin",
        "passwordConfirmation": "Passwort bestätigen"
      },
      "vehicle": {
        "name": "Name",
        "states": "Zustände",
        "serial": "Seriennummer",
        "owner": "befehligt von",
        "flagship": "Flaggschiff",
        "wanted": "Gewünscht",
        "loaner": "Leihschiff",
        "bundled": "Mitgeliefert",
        "bundledWith": "Mitgeliefert mit %{parent}",
        "public": "Öffentlich sichtbar",
        "fullPublic": "Öffentlich sichtbar inkl. Name",
        "publicShort": "Öffentlich",
        "nameVisible": "Öffentlich sichtbar",
        "saleNotify": "Ich möchte Angebotsbenachrichtigungen erhalten",
        "hangarGroups": "Gruppen",
        "selectGroup": "Gruppe auswählen",
        "modelPaintSelect": {
          "nullablePrompt": "Lackierung auswählen",
          "label": "Lackierung"
        },
        "bulkGroupEdit": {
          "hint": "Bestehende Gruppen werden überschrieben!"
        },
        "hasLoaners": "Leihschiffe",
        "boughtViaSelect": {
          "label": "Gekauft über"
        }
      },
      "image": {
        "active": "Aktiv?",
        "background": "Als Hintergrund verwenden?",
        "caption": "Beschriftung",
        "enabled": "Aktiviert?",
        "file": "Bilddatei",
        "global": "Global?",
        "delete": "Löschen",
        "start": "Starten",
        "cancel": "Abbrechen",
        "processing": "Verarbeitung...",
        "error": "Fehler",
        "name": "Name",
        "size": "Dateigröße",
        "dropzone": "Bilder hier ablegen",
        "cancelUpload": "Upload abbrechen",
        "startUpload": "Upload starten",
        "selectImages": "Bilder hinzufügen...",
        "selectFolder": "Ordner hinzufügen..."
      },
      "signup": {
        "link": "Haben Sie kein Konto?",
        "privacyPolicy": "Durch das Erstellen eines FleetYards-Kontos stimmen Sie unserer"
      },
      "privacyPolicy": "Datenschutzerklärung",
      "login": "Benutzername oder E-Mail",
      "username": "Benutzername",
      "twoFactorCode": "Zwei-Faktor-Code",
      "confirmationCode": "Bestätigungscode",
      "email": "E-Mail",
      "avatar": "Avatar",
      "alreadyRegistered": "Haben Sie bereits ein Konto?",
      "currentPassword": "Aktuelles Passwort",
      "password": "Passwort",
      "passwordConfirmation": "Passwort bestätigen",
      "rememberMe": "Angemeldet bleiben",
      "emptyList": "Keine %{name} vorhanden",
      "all": "Alle",
      "supportUs": "Support FleetYards.net",
      "account": {
        "destroyInfo": "If you want to delete Your Account and remove all your Information from Fleetyards.net and its Services click the Button below. Be aware of that this is a permanent Action and can't be reverted."
      },
      "fleets": {
        "logistics": {
          "inventoryCount": "inventories",
          "pending": "pending",
          "inProgress": "in progress",
          "drafts": "drafts",
          "noInventories": "No inventories yet.",
          "noRequests": "No requests found.",
          "noItems": "No items in this inventory.",
          "items": "items",
          "comments": "comments",
          "managedBy": "Managed by",
          "itemName": "Name",
          "category": "Category",
          "quantity": "Quantity",
          "unit": "Unit",
          "notes": "Notes",
          "status": "Status",
          "requested": "Requested",
          "fulfilled": "Fulfilled",
          "itemFulfilled": "Fulfilled",
          "itemPending": "Pending",
          "requestTitle": "Title",
          "description": "Description",
          "requestType": "Type",
          "priority": "Priority",
          "requestedBy": "Requested by",
          "approvedBy": "Approved by",
          "fulfilledBy": "Fulfilled by",
          "addComment": "Write a comment...",
          "states": {
            "draft": "Draft",
            "submitted": "Submitted",
            "approved": "Approved",
            "in_progress": "In Progress",
            "fulfilled": "Fulfilled",
            "rejected": "Rejected",
            "cancelled": "Cancelled"
          },
          "requestTypes": {
            "supply": "Supply",
            "outfitting": "Outfitting",
            "general": "General"
          },
          "priorities": {
            "routine": "Routine",
            "standard": "Standard",
            "urgent": "Urgent",
            "critical": "Critical"
          },
          "searchInventories": "Search inventories...",
          "inventoryName": "Inventory Name",
          "visibility": "Visibility",
          "visibilities": {
            "members_only": "All Members",
            "officers_only": "Officers Only"
          },
          "categories": {
            "commodity": "Commodity",
            "component": "Component",
            "module_item": "Module",
            "ship": "Ship",
            "ammunition": "Ammunition",
            "consumable": "Consumable",
            "other": "Other"
          },
          "units": {
            "scu": "SCU",
            "units": "Units"
          },
          "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
          "imported": "items imported",
          "importErrors": "errors"
        }
      },
      "filters": {
        "components": {
          "name": "Name",
          "itemType": "Gegenstandstyp",
          "componentClass": "Komponentenklasse"
        },
        "shops": {
          "name": "Name",
          "type": "Typ",
          "celestialObject": "Himmelskörper",
          "model": "Schiff",
          "equipment": "Ausrüstung",
          "component": "Komponente",
          "commodity": "Ware",
          "commodityType": "Warentyp",
          "starsystem": "Sternensystem",
          "station": "Station"
        },
        "shopCommodities": {
          "commodityType": "Warentyp",
          "station": "Station",
          "shopId": "Geschäft",
          "equipment": "Ausrüstung",
          "component": "Komponente",
          "componentItemTypeFilter": "Component Item Types",
          "equipmentItemTypeFilter": "Equipment Item Types",
          "equipmentTypeFilter": "Ausrüstungstyp",
          "equipmentSlotFilter": "Equipment Slot",
          "commodity": "Ware",
          "model": "Schiff",
          "name": "Name"
        },
        "shopItems": {
          "category": "Kategorie",
          "subCategory": "Unterkategorie",
          "name": "Name",
          "manufacturer": "Hersteller",
          "minPrice": "min. Price",
          "maxPrice": "max. Price"
        },
        "stations": {
          "name": "Name",
          "celestialObject": "Himmelskörper",
          "starsystem": "Sternensystem",
          "type": "Stationstyp",
          "shops": "Geschäfte",
          "docks": "Andockplätze",
          "habs": "Unterkunft?",
          "cargoHub": "Frachtzentrum?",
          "refinery": "Raffinerie-Station?"
        },
        "vehicles": {
          "name": "Name or Ship name",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "Preis <=",
          "priceGt": "Preis >=",
          "wanted": "Gewünscht",
          "hidden": "Versteckt",
          "public": "Öffentlich",
          "group": "Gruppe",
          "loaner": "Leihschiffe",
          "bundled": "Mitgelieferte Snub Crafts",
          "boughtVia": "Gekauft über?"
        },
        "tradeRoutes": {
          "sortBy": "Sort by",
          "sortByValues": {
            "percent": "Max. Percent",
            "profit": "Max. Profit"
          },
          "cargoShip": "With Cargoship?",
          "origin": "From?",
          "destination": "To?",
          "excludeCommodityType": "Exclude Commodity Type",
          "originCelestialObject": "Origin Celestial Object",
          "destinationCelestialObject": "Destination Celestial Object",
          "originStarsystem": "Origin Starsystem",
          "destinationStarsystem": "Destination Starsystem"
        },
        "models": {
          "name": "Name",
          "shipRole": "Schiffsrolle",
          "classification": "Klassifizierung",
          "focus": "Fokus",
          "manufacturer": "Hersteller",
          "onSale": "Im Angebot",
          "size": "Größe",
          "dockSize": "Dock-Größe",
          "price": "Preis",
          "pledgePrice": "Pledge-Preis",
          "productionStatus": "Produktionsstatus",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "beamLt": "Beam <=",
          "beamGt": "Beam >=",
          "heightLt": "Height <=",
          "heightGt": "Height >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "Preis <=",
          "priceGt": "Preis >=",
          "willItFit": "Will it Fit?",
          "withCargo": "Mit Fracht?",
          "scIdentifierBlank": "Ohne SC-Kennung?",
          "fleetchartImageBlank": "Ohne Flottenübersicht-Bild?",
          "holoBlank": "Ohne Holo?",
          "frontViewBlank": "Ohne Frontansicht-Bild?",
          "topViewColoredBlank": "Ohne farbige Draufsicht?"
        },
        "modelModules": {
          "name": "Name"
        },
        "manufacturers": {
          "name": "Name",
          "withModels": "Mit Modellen",
          "logoBlank": "Ohne Logo"
        },
        "supporterContributions": {
          "name": "Nach Name suchen",
          "recurring": "Wiederkehrend",
          "anonymous": "Anonym",
          "startedAtGteq": "Beginnt ab",
          "startedAtLteq": "Beginnt bis"
        },
        "images": {
          "station": "Station",
          "model": "Schiff"
        },
        "users": {
          "search": "Suchen",
          "username": "Benutzername",
          "email": "E-Mail",
          "rsiHandle": "RSI-Handle"
        },
        "fleets": {
          "name": "Name",
          "fid": "FID",
          "member": "Mitglied",
          "members": {
            "role": "Rolle",
            "state": "Status",
            "acceptedAtGt": "Beigetreten ab",
            "acceptedAtLt": "Beigetreten bis",
            "invitedAtGt": "Eingeladen ab",
            "invitedAtLt": "Eingeladen bis",
            "requestedAtGt": "Angefragt ab",
            "requestedAtLt": "Angefragt bis",
            "declinedAtGt": "Abgelehnt ab",
            "declinedAtLt": "Abgelehnt bis"
          },
          "inviteUrls": {
            "expiresAfter": "Expire after",
            "limit": "Max number of uses"
          }
        },
        "manufacturer": "Hersteller"
      },
      "station": {
        "docks": "Andockplätze",
        "location": "Standort",
        "type": "Typ",
        "habitation": "Unterkunft",
        "habs": "Unterkünfte",
        "shops": "Geschäfte",
        "locationPrefix": {
          "default": "on",
          "asteriod": "on asteroid near",
          "orbit": "in orbit around"
        },
        "locationSuffix": "near %{location}"
      },
      "tradeRoutes": {
        "buy": "Buy for: %{uec}",
        "sell": "Sell for: %{uec}",
        "cargoShip": "for %{cargo} SCU",
        "sortByPercent": "Sort by Percent",
        "sortByProfit": "Sort by Profit",
        "sortByStation": "Sort by Station",
        "showAveragePrices": "Display average Prices",
        "showLatestPrices": "Display latest Prices"
      },
      "hardpoints": {
        "prefix": "Konfigurationen testen mit",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer"
      },
      "scunpacked": {
        "prefix": "Loadouts based on Gamefiles powered by",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "Schiff auswählen"
      },
      "addAddon": {
        "nullablePrompt": ""
      },
      "table": {
        "selected": "%{count} ausgewählt"
      },
      "commodityPrice": {
        "shopId": "Geschäft",
        "station": "Station",
        "commodityItemType": "Warentyp",
        "commodityItemId": "Ware",
        "item": "ShopCommodity",
        "price": "Preis",
        "type": "Typ",
        "shop": "Geschäft",
        "submittedBy": "Eingereicht von"
      },
      "syncExtension": {
        "warnings": "Warnungen",
        "status": {
          "started": "Import gestartet...",
          "finished": "Import abgeschlossen",
          "failed": "Import fehlgeschlagen!"
        },
        "processSteps": {
          "fetchHangar": "Daten aus dem RSI-Hangar abrufen",
          "submitData": "Daten an das Fleetyards.net-Backend senden"
        },
        "sessionStatus": "RSI-Sitzungsstatus",
        "checkIdentity": "RSI-Sitzung prüfen",
        "identityStatus": {
          "pending": "Prüfe...",
          "notFound": "nicht gefunden",
          "connected": "verbunden"
        },
        "platforms": {
          "chrome": "Google Chrome",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "Seiten",
          "all": "Alle Pledge-Gegenstände",
          "ships": "Schiffe",
          "components": "Module",
          "skins": "Lackierungen",
          "upgrades": "Upgrades"
        },
        "importedItems": {
          "importedVehicles": "Hinzugefügte Schiffe",
          "foundVehicles": "Gefundene Schiffe",
          "movedVehiclesToWanted": "Schiffe auf Wunschliste verschoben",
          "missingModels": "Schiffe nicht gefunden",
          "importedComponents": "Hinzugefügte Komponenten",
          "foundComponents": "Gefundene Komponenten",
          "missingComponents": "Komponenten nicht gefunden",
          "missingComponentVehicles": "Kein passendes Schiff für Komponenten gefunden",
          "importedUpgrades": "Hinzugefügte Upgrades",
          "foundUpgrades": "Gefundene Upgrades",
          "missingUpgrades": "Upgrades nicht gefunden",
          "missingUpgradeVehicles": "Kein passendes Schiff für Upgrades gefunden",
          "new": "New",
          "updated": "Updated",
          "movedToWanted": "Moved to Wishlist",
          "missing": "Unable to Import"
        }
      },
      "cargoGridViewer": {
        "capacity": "Kapazität",
        "maxContainerSize": "Max. Container",
        "packed": "Gepackt",
        "totalCargo": "Gesamtfracht",
        "didNotFit": "Passte nicht",
        "openInTool": "Im Frachtraster-Tool öffnen",
        "myHangar": "Nur meine Schiffe anzeigen",
        "filterShips": "Schiffe nach Containergröße filtern",
        "addShip": "Schiff hinzufügen",
        "removeShip": "Entfernen",
        "autoFillShip": "Auto-Fill"
      },
      "admin": {
        "dashboard": {
          "quickStats": {
            "onlineUsers": "Online-Benutzer",
            "totalUsers": "Benutzer gesamt",
            "totalShips": "Schiffe gesamt",
            "newShipsInYear": "Neue Schiffe in %{year}",
            "totalFleets": "Flotten gesamt"
          }
        },
        "modelHardpoint": {
          "loadouts": "Konfigurationen"
        },
        "supporterContributions": {
          "source": {
            "patreon": "Patreon",
            "manual": "Manuell"
          }
        }
      },
      "hangarTable": {
        "extraColumns": "Spalten",
        "columns": {
          "storeImage": "Bild",
          "storeImageWide": "Breites Bild",
          "angledView": "3D-Bild",
          "angledViewWide": "Breites 3D-Bild",
          "modelManufacturerName": "Hersteller",
          "modelLength": "Länge",
          "modelBeam": "Breite",
          "modelHeight": "Höhe",
          "modelMass": "Masse",
          "modelCargo": "Fracht",
          "modelMinCrew": "Besatzung",
          "modelMaxCrew": "Max. Besatzung",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Max. Geschwindigkeit",
          "modelGroundMaxSpeed": "Bodengeschwindigkeit",
          "modelFocus": "Fokus",
          "modelProductionStatus": "Produktionsstatus",
          "modelPrice": "Preis",
          "modelPledgePrice": "Pledge-Preis"
        }
      },
      "fleetTable": {
        "extraColumns": "Spalten",
        "columns": {
          "storeImage": "Bild",
          "storeImageWide": "Breites Bild",
          "angledView": "3D Bild",
          "angledViewWide": "Breites 3D Bild",
          "modelManufacturerName": "Hersteller",
          "modelLength": "Länge",
          "modelBeam": "Breite",
          "modelHeight": "Höhe",
          "modelMass": "Masse",
          "modelCargo": "Fracht",
          "modelMinCrew": "Besatzung",
          "modelMaxCrew": "Max. Besatzung",
          "modelScmSpeed": "SCM Geschwindigkeit",
          "modelMaxSpeed": "Max Geschwindigkeit",
          "modelGroundMaxSpeed": "Bodengeschwindigkeit",
          "modelProductionStatus": "Produktionsstatus",
          "modelPrice": "Preis",
          "modelPledgePrice": "Pledge Preis",
          "owner": "Besitzer"
        }
      },
      "erkul": {
        "prefix": "Tryout Loadouts with",
        "link": "Erkul's DPS Calculator"
      }
    }
  }
}
